// translations.ts
export const translations = {
  accounts: {
    en: "Accounts",
    zh: "账户",
  },
  settings: {
    en: "Settings",
    zh: "设置",
  },
  logout: {
    en: "Logout",
    zh: "登出",
  },
  home: {
    en: "Home",
    zh: "主页",
  },
  help: {
    en: "Help",
    zh: "帮助",
  },
  hubspot: {
    en: "Hubspot",
    zh: "集线器点",
  },
  reports: {
    en: "Reports",
    zh: "报告",
  },
  containers: {
    en: "Containers",
    zh: "集装箱",
  },
  operations: {
    en: "Operations",
    zh: "运营",
  },
  delivery: {
    en: "Delivery",
    zh: "送货",
  },
  tracker: {
    en: "Tracker",
    zh: "追踪",
  },
  operationalScans: {
    en: "OperationalScans",
    zh: "操作扫描",
  },
  production: {
    en: "Production",
    zh: "生产",
  },
  accountSettings: {
    en: "Account Settings",
    zh: "账户设置",
  },
  userSettings: {
    en: "User Settings",
    zh: "用户设置",
  },
  usersManagement: {
    en: "Users Management",
    zh: "用户管理",
  },
  organizationSettings: {
    en: "Organisation Settings",
    zh: "组织设置",
  },
  organizationManagement: {
    en: "Organisation Management",
    zh: "组织管理",
  },
  notifications: {
    en: "Notifications",
    zh: "通知",
  },
  signOut: {
    en: "Sign Out",
    zh: "登出",
  },
  customerOrderTracker: {
    en: "Customer Order Tracker",
    zh: "追踪客户订单",
  },
  chinaOrderTracker: {
    en: "China Order Tracker",
    zh: "追踪中国订单",
  },
  incomingStatus: {
    en: "Incoming Status",
    zh: "传入状态",
  },
  trackerDashboard: {
    en: "Tracker Dashboard",
    zh: "追踪器仪表板",
  },
  // Customer Order Tracker
  orderNumber: {
    en: "Order No",
    zh: "订单号",
  },
  itemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  chinaItemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  globalItemCode: {
    en: "Item Code",
    zh: "商品代码",
  },
  itemName: {
    en: "Item Name",
    zh: "商品名称",
  },
  customerName: {
    en: "Customer Name",
    zh: "客户名称",
  },
  orderDate: {
    en: "Order Date",
    zh: "订购日期",
  },
  orderQty: {
    en: "Order Qty",
    zh: "订单数量",
  },
  Qty: {
    en: "Qty",
    zh: "数量",
  },
  gwTotal: {
    en: "Gross Weight",
    zh: "毛重",
  },
  nwTotal: {
    en: "Net Weight",
    zh: "净重",
  },
  progress: {
    en: "Progress",
    zh: "进度",
  },
  requestDate: {
    en: "Request Date",
    zh: "请求日期",
  },
  location: {
    en: "Location",
    zh: "地点",
  },
  state: {
    en: "State",
    zh: "省份",
  },
  daysLeft: {
    en: "Days Left",
    zh: "剩余天数",
  },
  orderStatus: {
    en: "Order Status",
    zh: "订单状态",
  },
  actions: {
    en: "Actions",
    zh: "安排",
  },
  totalItems: {
    en: "Total Items",
    zh: "总项目",
  },
  quickFilter: {
    en: "Quick Filter",
    zh: "快速过滤器",
  },

  updateShipment: {
    en: "Update Shipment",
    zh: "更新发货",
  },

  shipmentActions: {
    en: "Actions",
    zh: "安排",
  },

  // Incoming Statuses
  incoming: {
    en: "Incoming",
    zh: "传入",
  },
  approved: {
    en: "Approved",
    zh: "得到正式认可的",
  },
  rejected: {
    en: "Rejected",
    zh: "被拒绝",
  },
  revised_by_purchasing: {
    en: "REVISED BY PURCHASING",
    zh: "采购部修订",
  },

  // Quick Filters
  all: {
    en: "All",
    zh: "全部",
  },
  onHold: {
    en: "Onhold",
    zh: "搁置",
  },
  closed: {
    en: "Closed",
    zh: "关闭",
  },
  newOrder: {
    en: "New Order",
    zh: "新订单",
  },
  arrived: {
    en: "Arrived",
    zh: "到达的",
  },
  shipped: {
    en: "Shipped",
    zh: "已发货",
  },
  rushOrder: {
    en: "Rush Order",
    zh: "加急订单",
  },
  orderPlaced: {
    en: "Order Placed",
    zh: "已下订单",
  },
  atRisk: {
    en: "At Risk",
    zh: "有风险订单",
  },
  planned: {
    en: "Planned",
    zh: "计划",
  },
  completed: {
    en: "Completed",
    zh: "完全的",
  },
  interrupted: {
    en: "Interrupted",
    zh: "被打断",
  },
  //China tracker
  onTime: {
    en: "On Time",
    zh: "准时交货",
  },
  delayed: {
    en: "Delayed",
    zh: "延迟",
  },
  msRef: {
    en: "MS No",
    zh: "MS订单号",
  },
  priorityOrder: {
    en: "Priority Order",
    zh: "优先订单",
  },

  high: {
    en: "High",
    zh: "高的",
  },

  normal: {
    en: "Normal",
    zh: "普通的",
  },

  add: {
    en: "Add",
    zh: "添加",
  },

  delete: {
    en: "Delete",
    zh: "删除",
  },

  medium: {
    en: "Medium",
    zh: "中等的",
  },

  allocateProductionLine: {
    en: "Prod. Line",
    zh: "生产线",
  },
  artworkNo: {
    en: "Artwork No",
    zh: "贴纸编号",
  },
  qtyToShip: {
    en: "Qty to Ship",
    zh: "剩余未交数量",
  },
  fulfillmentPercent: {
    en: "Fulfilment %",
    zh: "订单履约率",
  },
  ausInventory: {
    en: "Aus Inventory",
    zh: "澳洲库存",
  },
  noData: {
    en: "No Data",
    zh: "没有资料",
  },
  run1: {
    en: "Run 1",
    zh: "生产批次 1",
  },
  run2: {
    en: "Run 2",
    zh: "生产批次 2",
  },
  plannedQuantity: {
    en: "Planned Quantity",
    zh: "计划生产数量",
  },
  artworkNumber: {
    en: "Artwork Number",
    zh: "贴纸编号",
  },
  addMoreRun: {
    en: "Add more run",
    zh: "增加生产次数",
  },
  reviewRejectedOrder: {
    en: "Review rejected order",
    zh: "审查被拒绝订单",
  },
  interruptRunOrder: {
    en: "Interrupt Run Order",
    zh: "中断运行",
  },
  resumeRunOrder: {
    en: "Resume Run Order",
    zh: "恢复运行",
  },
  interruptRunOrderNotice: {
    en: "Interrupting this run order will pause its execution and may impact downstream processes.",
    zh: "中断此运行将会暂停此订单执行，并可能会影响此订单往后的进程。",
  },
  resumeRunOrderNotice: {
    en: "This run order is currently interrupted. Resuming will return it to the normal execution flow.",
    zh: "此运行正处于中断状态。恢复后，它将返回正常的执行流程。",
  },
  productionLine: {
    en: "Production Line",
    zh: "生产线",
  },
  runOrder: {
    en: "Run Order",
    zh: "运行顺序",
  },
  messageRequired: {
    en: "Message is required",
    zh: "消息为必填项",
  },
  explainInterruptRunOrder: {
    en: "Explain why this run order needs to be interrupted...",
    zh: "请提供需要中断此运行的原因。",
  },
  explainResumeRunOrder: {
    en: "Explain why you are resuming this run order...",
    zh: "请提供恢复运行的原因。",
  },
  runOrderResumedSuccess: {
    en: "Run order resumed successfully",
    zh: "运行已成功恢复",
  },
  runOrderInterruptedSuccess: {
    en: "Run order interrupted successfully",
    zh: "运行已成功中断",
  },
  actionFailed: {
    en: "Action failed",
    zh: "操作失败",
  },
  resume: {
    en: "Resume",
    zh: "恢复",
  },
  interrupt: {
    en: "Interrupt",
    zh: "中断",
  },
  newRequest: {
    en: "New request",
    zh: "新要求",
  },
  message: {
    en: "Message",
    zh: "消息",
  },
  awaitingPurchasingApproval: {
    en: "Awaiting purchasing approval",
    zh: "等待确认",
  },
  awaitingForYourResponse: {
    en: "Awaiting for your response",
    zh: "等待工厂回复",
  },
  poOrderDate: {
    en: "PO Order Date",
    zh: "订单日期",
  },
  labelOrder: {
    en: "Label Ready",
    zh: "贴纸已订",
  },
  soakarPad: {
    en: "Soakar Pad",
    zh: "吸水垫",
  },
  directShipment: {
    en: "Direct Shipment",
    zh: "直接发货",
  },
  Run: {
    en: "Run Order",
    zh: "运行顺序",
  },
  planStartDay: {
    en: "Planned Start Date",
    zh: "预计生产日期",
  },
  actualStartDay: {
    en: "Act. Start Date",
    zh: "真实生产日期",
  },
  duration: {
    en: "Duration (Days)",
    zh: "持续时间（天）",
  },

  Duration: {
    en: "Duration (Days)",
    zh: "持续时间（天）",
  },

  actualCompletionDate: {
    en: "Act. Completion Date",
    zh: "实际完成日期",
  },
  expectedArrival: {
    en: "ETA (To Store)",
    zh: "预计到达",
  },
  estCompletion: {
    en: "Est. Completion Date",
    zh: "预计完成日期",
  },
  estPack: {
    en: "Est. Pack",
    zh: "预计装柜日期",
  },
  etd: {
    en: "ETD",
    zh: "预计送货日期",
  },
  eta: {
    en: "ETA",
    zh: "预计到达时间",
  },
  shippingDeadline: {
    en: "Shipping Deadline",
    zh: "最迟起航日期",
  },
  search: {
    en: "Search",
    zh: "搜索",
  },
  shipmentSearchPlaceholder: {
    en: "Enter Shipment Container Number",
    zh: "请输入货运集装箱编号",
  },

  shippingLine: {
    en: "Shipping Line",
    zh: "船公司",
  },
  newShippingDeadline: {
    en: "New Shipping Deadline",
    zh: "最遲起航日期（新）",
  },
  customer: {
    en: "Customer",
    zh: "客户名称",
  },
  item: {
    en: "Item",
    zh: "商品",
  },
  subject: {
    en: "Subject",
    zh: "主题",
  },
  priority: {
    en: "Priority",
    zh: "优先",
  },
  low: {
    en: "Low",
    zh: "低",
  },
  sealNo: {
    en: "Seal No",
    zh: "封条号",
  },
  selectPriority: {
    en: "Select Priority",
    zh: "选择优先",
  },
  orderIssue: {
    en: "High",
    zh: "订单问题",
  },
  productInquiry: {
    en: "Product Inquiry",
    zh: "产品查询",
  },
  other: {
    en: "Other",
    zh: "其他",
  },
  selectSubject: {
    en: "Select Subject",
    zh: "选择主题",
  },
  prodcutionline: {
    en: "Production Line",
    zh: "生产线",
  },
  incomingOrder: {
    en: "Incoming Order",
    zh: "收到订单",
  },

  transferOrder: {
    en: "Transfer Order",
    zh: "调令",
  },

  upcomingMonth: {
    en: "Upcoming Month",
    zh: "未来一个月",
  },
  nextMonth: {
    en: "Next Month",
    zh: "下个月",
  },
  threeMonths: {
    en: "3 Months",
    zh: "三个月",
  },
  sixMonths: {
    en: "6 Months",
    zh: "六个月",
  },
  requestDateAlerts: {
    en: "Alerts",
    zh: "请求日期警报",
  },
  ordersLabel: {
    en: "Orders",
    zh: "订单",
  },
  overdue: {
    en: "Overdue",
    zh: "已逾期",
  },
  next7Days: {
    en: "Next 7 Days",
    zh: "未来7天",
  },
  next14Days: {
    en: "Next 14 Days",
    zh: "未来14天",
  },
  next30Days: {
    en: "Next 30 Days",
    zh: "未来30天",
  },
  loadingOrders: {
    en: "Loading orders...",
    zh: "正在加载订单...",
  },
  loading: {
    en: "Loading...",
    zh: "加载中...",
  },
  noOrdersInTimeframe: {
    en: "No orders in the selected timeframe",
    zh: "所选时间范围内没有订单",
  },
  allCaughtUp: {
    en: "All caught up! Great job staying on schedule.",
    zh: "全部完成！非常棒，继续保持进度。",
  },
  itemLabel: {
    en: "Item",
    zh: "商品",
  },
  codeLabel: {
    en: "Code",
    zh: "代码",
  },
  quantityLabel: {
    en: "Quantity",
    zh: "数量",
  },
  statusLabel: {
    en: "Status",
    zh: "状态",
  },
  today: {
    en: "Today",
    zh: "今天",
  },
  day: {
    en: "day",
    zh: "天",
  },
  days: {
    en: "days",
    zh: "天",
  },
  dayAgo: {
    en: "day ago",
    zh: "天前",
  },
  daysAgo: {
    en: "days ago",
    zh: "天前",
  },
  urgencyOverdue: {
    en: "OVERDUE",
    zh: "已逾期",
  },
  urgencyDueToday: {
    en: "DUE TODAY",
    zh: "今天到期",
  },
  urgencyDueTomorrow: {
    en: "DUE TOMORROW",
    zh: "明天到期",
  },
  urgencyUrgent: {
    en: "URGENT",
    zh: "紧急",
  },
  urgencySoon: {
    en: "SOON",
    zh: "即将",
  },
  urgencyUpcoming: {
    en: "UPCOMING",
    zh: "即将到来",
  },
  urgencyFuture: {
    en: "FUTURE",
    zh: "未来",
  },
  notAvailable: {
    en: "N/A",
    zh: "无",
  },
  checklist: {
    en: "Checklist",
    zh: "清单",
  },
  reviewRejectedOrders: {
    en: "Rejected Orders",
    zh: "审核被拒绝的订单",
  },
  allOrders: {
    en: "All Orders",
    zh: "所有订单",
  },
  pending: {
    en: "Pending",
    zh: "待办",
  },
  rejectedOrders: {
    en: "Rejected Orders",
    zh: "被拒绝的订单",
  },
  cancelledOrders: {
    en: "Cancelled Orders",
    zh: "取消订单",
  },
  archievedOrders: {
    en: "Archived Orders",
    zh: "已归档订单",
  },
  cancelled: {
    en: "Cancelled",
    zh: "取消",
  },
  dueDate: {
    en: "Due Date",
    zh: "到期日",
  },
  newDueDate: {
    en: "New Due Date",
    zh: "到期日（新）",
  },
  newOrderQty: {
    en: "New Order Qty",
    zh: "订单数量（新）",
  },
  flaggedOrderNumber: {
    en: "Flagged Order Number",
    zh: "标记的订单号",
  },
  vesselScheduling: {
    en: "Vessel Full Re-Scheduling",
    zh: "货船行程变更",
  },
  machineBroken: {
    en: "Machine Broken Down",
    zh: "机器故障",
  },
  selectasubejct: {
    en: "Select a subject",
    zh: "选择主题",
  },
  newduedate: {
    en: "New due date",
    zh: "新的到期日",
  },
  neworderqty: {
    en: "New order qty",
    zh: "新的订单数量",
  },

  newshippingdeadline: {
    en: "New shipping dealine",
    zh: "新的出货截止日期",
  },
  close: {
    en: "Close",
    zh: "关闭",
  },
  submit: {
    en: "Submit",
    zh: "提交",
  },
  cancel: {
    en: "Cancel",
    zh: "取消",
  },
  resubmit: {
    en: "Resubmit",
    zh: "重新提交",
  },
  shipments: {
    en: "Shipments",
    zh: "装运",
  },

  addNew: {
    en: "Add New",
    zh: "新增",
  },
  run: {
    en: "Run",
    zh: "运行",
  },
  plannedQtyWarning: {
    en: "Planned quantity exceeds recommended max",
    zh: "计划数量超出建议最大值",
  },
  enterContainerNumber: {
    en: "Enter container number",
    zh: "输入集装箱号",
  },
  enterDurationDays: {
    en: "Enter duration days",
    zh: "输入持续天数",
  },
  enterRemarksOptional: {
    en: "Enter remarks (optional)",
    zh: "输入备注（可选）",
  },
  shipmentCreatedSuccess: {
    en: "Shipment created successfully",
    zh: "货件创建成功",
  },
  shipmentCreateFailed: {
    en: "Failed to create shipment:",
    zh: "创建货件失败：",
  },
  pleaseFillPlannedQty: {
    en: "Please fill in the Planned Quantity.",
    zh: "请填写计划数量。",
  },
  pleaseSelectProductionLine: {
    en: "Please select a Production Line.",
    zh: "请选择生产线。",
  },
  pleaseEnterDuration: {
    en: "Please enter a Duration.",
    zh: "请输入持续时间。",
  },
  containerNumberRequired: {
    en: "Container number is required",
    zh: "请填写集装箱号",
  },
  etdRequired: {
    en: "ETD is required",
    zh: "请填写预计出货日",
  },
  durationRequired: {
    en: "Duration is required",
    zh: "请填写持续时间",
  },
  pleaseSelectDate: {
    en: "Please select a date.",
    zh: "请选择日期。",
  },
  factoryOrderCreateSuccess: {
    en: "Factory order detail created successfully!",
    zh: "工厂订单明细创建成功！",
  },
  factoryOrderError: {
    en: "Error in factory order detail:",
    zh: "工厂订单明细出错：",
  },

  resolvedDate: {
    en: "Resolved Date",
    zh: "解决日期",
  },
  createdAt: {
    en: "Created Date",
    zh: "查询日期",
  },
  createdBy: {
    en: "User",
    zh: "用户",
  },
  history: {
    en: "History",
    zh: "历史",
  },

  flagged: {
    en: "Flagged",
    zh: "已标记",
  },
  interrupts: {
    en: "Interrupts",
    zh: "中断",
  },
  enquiries: {
    en: "Enquiries",
    zh: "查询",
  },

  askEnquiry: {
    en: "Ask Enquiry",
    zh: "询问",
  },

  createdByName: {
    en: "User",
    zh: "用户",
  },
  generatedBy: {
    en: "Generated By",
    zh: "用户",
  },
  approvedBy: {
    en: "Approved By",
    zh: "批准人",
  },
  updatePriority: {
    en: "Update Priority",
    zh: "更新优先级",
  },
  rejectOrderNumber: {
    en: "Reject Order Number",
    zh: "被拒订单",
  },

  reject: {
    en: "Reject",
    zh: "拒绝",
  },

  accept: {
    en: "Accept",
    zh: "接受",
  },

  enterQuantity: {
    en: "Enter Quantity",
    zh: "输入数量",
  },

  typeYourMessage: {
    en: "Type your message...",
    zh: "输入消息",
  },

  checkList: {
    en: "Checklist",
    zh: "订单清单",
  },

  itemsSelected: {
    en: "Item Selected",
    zh: "已选择商品",
  },

  revise: {
    en: "Revise",
    zh: "修订",
  },
  chinaordernumber: {
    en: "Order Number",
    zh: "订单编号",
  },

  createShipment: {
    en: "Create Shipment",
    zh: "创建货件",
  },

  shipmentNo: {
    en: "Shipment No",
    zh: "发货编号",
  },

  shipmentQty: {
    en: "Shipment Qty",
    zh: "出货数量",
  },

  containerNo: {
    en: "Container No",
    zh: "集装箱号",
  },

  ETA_ToStore: {
    en: "ETA To Store",
    zh: "预计到达时间",
  },

  remarks: {
    en: "Remarks",
    zh: "评论",
  },

  addNewRun: {
    en: "Add New Run",
    zh: "添加新生产",
  },

  addDirectShipment: {
    en: "Add Direct Shipment",
    zh: "添加直接送货",
  },

  interruptType: {
    en: "Interrupt Type",
    zh: "中断类型",
  },

  interruptedBy: {
    en: "Interrupted By",
    zh: "被打断",
  },

  generateShipment: {
    en: "Generate Shipment",
    zh: "生成发货",
  },

  incomingShipment: {
    en: "Incoming Shipment",
    zh: "进货",
  },

  chinaShipment: {
    en: "China Shipment",
    zh: "中国发货",
  },

  globalShipment: {
    en: "Global Shipment",
    zh: "全球发货",
  },

  chinaShipmentDetailsReport: {
    en: "China Shipment Details Report",
    zh: "中国出货详情报告",
  },

  globalShipmentDetailsReport: {
    en: "Global Shipment Details Report",
    zh: "全球发货详情报告",
  },

  vesselVoyage: {
    en: "Vessel / Voyage",
    zh: "船名 / 航次",
  },
  seaFreight: {
    en: "Sea Freight",
    zh: "海运费",
  },
  freightLine: {
    en: "Freight Line",
    zh: "货运线路",
  },
  itemDescription: {
    en: "Item Description",
    zh: "商品描述",
  },
  material: {
    en: "Material",
    zh: "材料",
  },
  label: {
    en: "Label",
    zh: "标签",
  },
  spec: {
    en: "Spec",
    zh: "规格",
  },
  quantity: {
    en: "Quantity",
    zh: "数量",
  },
  grossWeight: {
    en: "Gross Weight",
    zh: "毛重",
  },
  netWeight: {
    en: "Net Weight",
    zh: "净重",
  },
  notes: {
    en: "Notes",
    zh: "备注",
  },
  noImage: {
    en: "No Image",
    zh: "无图片",
  },
};

export const customerOrderTrackerTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  OrderNumber1: "orderNumber",
  ItemCode: "itemCode",
  ItemName: "itemName",
  BPName: "customerName",
  OrderDate: "orderDate",
  TotalOrdered: "orderQty",
  progress: "progress",
  RequestDate: "requestDate",
  StateDelivery: "location",
  DaysLeft: "daysLeft",
  OrderStatus: "orderStatus",
  trackerActions: "actions",
  trackerActions_sm: "actions",
  NewDueDate: "newDueDate",
  NewOrderQty: "newOrderQty",
  NewShippingDeadline: "newShippingDeadline",
  Reject: "reject",
  Accept: "accept",
  CheckList: "checkList",
};

export const chinaTrackerTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  Revise: "revise",
  ItemsSelected: "itemsSelected",
  CheckList: "checkList",
  TypeYourMessage: "typeYourMessage",
  EnterQuantity: "enterQuantity",
  Accept: "accept",
  Reject: "reject",
  RejectOrderNumber: "rejectOrderNumber",
  RequestDate: "requestDate",
  OrderNumber1: "orderNumber",
  ItemCode: "itemCode",
  ItemName: "itemName",
  BPName: "customerName",
  OrderDate: "orderDate",
  TotalOrdered: "orderQty",
  ETA: "eta",
  StateDelivery: "location",
  OrderStatus: "orderStatus",
  incomingStatus: "incomingStatus",
  PriorityOrder: "priorityOrder",
  MSRef: "msRef",
  MSNo: "msRef",
  ArtworkNo: "artworkNo",
  AllocateProductionLine: "allocateProductionLine",
  QtyToShip: "qtyToShip",
  FulfillmentPercent: "fulfillmentPercent",
  AusInventory: "ausInventory",
  actions: "actions",
  Actions: "actions",
  soakarPad: "soakarPad",
  directShipment: "directShipment",
  labelOrder: "labelOrder",
  Run: "Run",
  PlannedQty: "plannedQuantity",
  plannedQty: "plannedQuantity",
  allocateProductionLine: "allocateProductionLine",
  PlanStartDay: "planStartDay",
  planStartDay: "planStartDay",
  ActualStartDay: "actualStartDay",
  actualStartDay: "actualStartDay",
  ESTCompletion: "estCompletion",
  ESTCompletionDate: "estCompletion",
  ActualCompletionDate: "actualCompletionDate",
  actualCompletionDate: "actualCompletionDate",
  ExpectedArrival: "expectedArrival",
  ESTPack: "estPack",
  ESTPackDate: "estPack",
  ETD: "etd",
  ShippingDeadline: "shippingDeadline",
  shippingDeadline: "shippingDeadline",
  NewShippingDeadline: "newShippingDeadline",
  Customer: "customer",
  Item: "item",
  OrderPlaced: "orderPlaced",
  Subject: "subject",
  Priority: "priority",
  priority: "priority",
  Low: "low",
  High: "high",
  SelectPriority: "selectPriority",
  OrderIssue: "orderIssue",
  ProductInquiry: "productInquiry",
  Other: "other",
  SelectSubject: "selectSubject",
  Message: "message",
  POOrderDate: "poOrderDate",
  DueDate: "dueDate",
  NewDueDate: "newDueDate",
  NewOrderQty: "newOrderQty",
  State: "state",
  OrderQty: "orderQty",
  subject: "subject",
  createdAt: "createdAt",
  createdBy: "createdBy",
  message: "message",
  runOrder: "Run",
  // trackerActions: "actions",
  // trackerActions_sm: "actions",
  resolvedDate: "resolvedDate",
  createdByName: "createdByName",
  Duration: "duration",
  duration: "duration",
  chinaordernumber: "chinaordernumber",
  interruptType: "interruptType",
  interruptedBy: "interruptedBy",
};

export const chinaShipmentTranslationMap: Record<
  string,
  keyof typeof translations
> = {
  containerNo: "containerNo",
  location: "location",
  ETD: "etd",
  ETA: "eta",
  shippingLine: "shippingLine",
  sealNo: "sealNo",
  generatedBy: "generatedBy",
  createdAt: "createdAt",
  gwTotal: "gwTotal",
  nwTotal: "nwTotal",
  itemCode: "itemCode",
  qtyTotal: "Qty",
  orderNumber: "orderNumber",
  Accept: "accept",
  chinaItemCode: "chinaItemCode",
  globalItemCode: "globalItemCode",
  approvedBy: "approvedBy",
  vesselVoyage: "vesselVoyage",
  freightLine: "freightLine",
  itemDescription: "itemDescription",
  material: "material",
  spec: "spec",
  label: "label",
  quantity: "quantity",
  grossWeight: "grossWeight",
  netWeight: "netWeight",
  notes: "notes",
  generateShipment: "generateShipment",
};
